import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import Lock from 'react-feather/dist/icons/lock'

const Navbar = props => (
  <Wrapper> 
    <div className='action'></div>
    <div className="brand ">
      <Link activeClassName="active" exact to="/">
        shotsnapp
      </Link>
    </div>

    <div className="action" style={{ textAlign: 'right' }}>
      <a href="https://app.shotsnapp.com/login">
        <Lock size={15} />
        Log in
      </a>
      {props.transparent && (
        <a className="try" href="https://app.shotsnapp.com">
          Try now
        </a>
      )}
    </div>
  </Wrapper>
)

export default Navbar

const Wrapper = styled.div`
  height: 54px;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
  z-index: 9999;
  position: absolute;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  
  .brand { 
    text-align: center;
    a {
      font-weight: 700;
      font-size: 20px;
      color: #eee;
      text-decoration: none;
      -webkit-font-smoothing: antialiased;

      &:hover {
        color: #fff;
      }
    }
  }

  .action {  
    width:100px;
    text-align: right;
    justify-content: flex-end;
    @media (max-width: 600px) {
      flex: 1;
    }

    svg {
      vertical-align: -2px;
      margin-right: 5px;
    }
  }
  a {
    color: #fff;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .try {
    background: #fff;
    color: #333;
    &:hover {
      background: #fff;
      color: #333;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Navbar.js